import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-test-consent-dialog',
  templateUrl: './test-consent-dialog.component.html',
  styleUrls: ['./test-consent-dialog.component.css']
})
export class TestConsentDialogComponent {

  email: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TestConsentDialogComponent>
  ) {}

  test() {
    this.data.testConsent(this.data.consent.id, this.email);
    this.dialogRef.close(); 
  }
}
